function isVerticallyScrollable(el: Element): boolean {
  const { overflowY } = window.getComputedStyle(el);
  if (overflowY !== "auto" && overflowY !== "scroll" && overflowY !== "overlay") {
    return false;
  }
  return el.scrollHeight > el.clientHeight + 1;
}

function isHorizontallyScrollable(el: Element): boolean {
  const { overflowX } = window.getComputedStyle(el);
  if (overflowX !== "auto" && overflowX !== "scroll" && overflowX !== "overlay") {
    return false;
  }
  return el.scrollWidth > el.clientWidth + 1;
}

function findVerticallyScrollableAncestor(start: EventTarget | null): Element | null {
  let el = start instanceof Element ? start : null;
  while (el && el !== document.documentElement) {
    if (isVerticallyScrollable(el)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

function findHorizontallyScrollableAncestor(start: EventTarget | null): Element | null {
  let el = start instanceof Element ? start : null;
  while (el && el !== document.documentElement) {
    if (isHorizontallyScrollable(el)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

function atVerticalScrollBoundary(el: Element, deltaY: number): boolean {
  if (deltaY < 0) {
    return el.scrollTop <= 0;
  }
  return el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
}

function preventIfCancelable(e: TouchEvent): void {
  if (e.cancelable) {
    e.preventDefault();
  }
}

/** 禁止整页橡皮筋；允许 .space-home-sheet-body / .lf-h5-space-main / .h5-sub-page__body 等内部滚动 */
export function preventDocumentRubberBand(): () => void {
  let startX = 0;
  let startY = 0;

  const onTouchStart = (e: TouchEvent) => {
    startX = e.touches[0]?.clientX ?? 0;
    startY = e.touches[0]?.clientY ?? 0;
  };

  const onTouchMove = (e: TouchEvent) => {
    const x = e.touches[0]?.clientX ?? 0;
    const y = e.touches[0]?.clientY ?? 0;
    const deltaX = startX - x;
    const deltaY = startY - y;

    const horizontalScrollable = findHorizontallyScrollableAncestor(e.target);
    if (horizontalScrollable && Math.abs(deltaX) > Math.abs(deltaY)) {
      // 横向滑动交给浏览器原生处理，避免与 document 级 preventDefault 冲突
      return;
    }

    const scrollable = findVerticallyScrollableAncestor(e.target);
    if (!scrollable) {
      preventIfCancelable(e);
      return;
    }
    if (atVerticalScrollBoundary(scrollable, deltaY)) {
      preventIfCancelable(e);
    }
  };

  document.addEventListener("touchstart", onTouchStart, { passive: true });
  document.addEventListener("touchmove", onTouchMove, { passive: false });

  return () => {
    document.removeEventListener("touchstart", onTouchStart);
    document.removeEventListener("touchmove", onTouchMove);
  };
}
